import { render, staticRenderFns } from "./MusicPlayer.vue?vue&type=template&id=00546df7&"
import script from "./MusicPlayer.vue?vue&type=script&lang=js&"
export * from "./MusicPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MusicPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports